import React, { FC, useEffect, useState } from "react";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import SuccessModal from "../../../../components/cards/SuccesCard";

interface ResetPasswordProp {
  onClose: () => void;
}

const ResetPassword: FC<ResetPasswordProp> = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [openResetSuccess, setOpenResetSuccess] = useState(false);

  useEffect(() => {
    setCurrentStep(1);
  }, []);

  return (
    <>
      <StepOne
        open={currentStep === 1}
        onSuccess={() => setCurrentStep(3)}
        onAlternateClick={() => setCurrentStep(2)}
        onClose={() => {
          setCurrentStep(1);
          onClose();
        }}
      />
      <StepTwo
        open={currentStep === 2}
        onSuccess={() => setCurrentStep(3)}
        onDefaultClick={() => setCurrentStep(1)}
        onClose={() => {
          setCurrentStep(1);
          onClose();
        }}
      />
      <StepThree
        open={currentStep === 3}
        onSuccess={() => setCurrentStep(4)}
        onClose={() => {
          setCurrentStep(1);
          onClose();
        }}
      />
      <StepFour
        open={currentStep === 4}
        onSuccess={() => {
          setOpenResetSuccess(true);
          setCurrentStep(0);
        }}
        onClose={() => {
          setCurrentStep(1);
          onClose();
        }}
      />
      <SuccessModal
        isOpen={openResetSuccess}
        onClose={() => setOpenResetSuccess(false)}
        title="Successful Password Reset!"
        description="You can now use your new password to log in to your account "
        onConfirm={() => {
          setOpenResetSuccess(false);
          onClose();
          setCurrentStep(1);
        }}
        confirmText="Confirm"
      />
    </>
  );
};

export default ResetPassword;
